import { useAuthentication } from '@psyomics/ui-common';
import { LoadingSpinner, LoggedOut } from '@psyomics/ui-components';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useOrgCodeFromSession = () => {
  const [orgCode, setOrgCode] = useState<string | undefined>(undefined);
  useEffect(() => {
    const loggedOutOrgCode = sessionStorage.getItem('loggedOutOrgCode');
    if (loggedOutOrgCode) {
      sessionStorage.removeItem('loggedOutOrgCode');
      setOrgCode(loggedOutOrgCode);
    }
  }, []);

  return orgCode;
};

const LoggedOutView = () => {
  const [loading, setLoading] = useState(true);
  const [automaticSso, setAutomaticSso] = useState(false);
  const navigate = useNavigate();
  const { getOrgSettings } = useAuthentication();

  const orgCode = useOrgCodeFromSession();

  useEffect(() => {
    (async () => {
      if (orgCode) {
        const organisation = await getOrgSettings(orgCode);
        setAutomaticSso(!organisation.defaultClientId);
      }
      setLoading(false);
    })();
  }, [setAutomaticSso, getOrgSettings, orgCode]);

  const handleSignInClick = useCallback(() => {
    navigate(`../account/${orgCode}`);
  }, [navigate, orgCode]);

  if (loading) {
    return <LoadingSpinner />;
  }
  return (
    <div className="mt-30 container">
      <LoggedOut
        automaticSso={automaticSso}
        handleSignIn={orgCode !== undefined ? handleSignInClick : undefined}
      ></LoggedOut>
    </div>
  );
};

export { LoggedOutView };
